import React from "react";
import { LandingPageShell } from "./layout/LandingPageShell";
import { PageTemplate } from "../PageTemplate/PageTemplate";
import { useCategories } from "../../hooks";

/*
 * This file is the main entry point for the landing page.
 * It can be used to set up any necessary context providers or global state for the landing page,
 *  and then render the LandingPageShell which contains the actual layout and content of the page.
 */

export const LandingPage: React.FC = () => {
  // Shares the cached "categories" query with CategoriesSection - no extra fetch.
  const { loading } = useCategories();

  return (
    <PageTemplate data-id="landing-page" isReady={!loading}>
      <LandingPageShell />
    </PageTemplate>
  );
};
